export const quantiacs = {
    homePage: {
        siteName: 'quantiacs',
        logUrl:
            'https://www.quantiacs.com/QuantNetSite/media/BindTuning-SPCTheme/quantiacs-logo.png?width=283&height=63&ext=.png',

        contacts: {
            emailSupport: {
                name: 'Email',
                title: 'info@quantiacs.com',
                link: 'mailto:info@quantiacs.com',
            },

            youtube: {
                name: 'Youtube',
                title: 'Youtube',
                link: 'https://www.youtube.com/channel/UCS8bIV3uEJLIaA91s5uQzQw',
            },
        },
    },
    general: {
        currency: 'USD',
        logoClassName: 'quantiacs-logo',
    },

    account: {
        contacts: {
            gitHub: {
                name: 'GitHub',
                title: 'qntnet',
                link: 'https://github.com/qntnet',
            },
            emailSupport: {
                name: 'Email',
                title: 'info@quantiacs.com',
                link: 'mailto:info@quantiacs.com',
            },
        },
    },
};
